import apiConfig from '@constants/apiConfig';

import KitplayRequestListPage from '.';

export default {
    kitplayRequestListPage: {
        path: '/kitplay-request',
        title: 'Digibes request',
        auth: true,
        component: KitplayRequestListPage,
        permission: [apiConfig.kitplayRequest.getList.baseURL],
    },
};
